import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';
import Button from 'components/Button';
import ThrottleHistoryModal from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/scenes/ThrottleHistoryModal';
import { Throttle } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

import { Theme } from 'config';

import {
  formatThrottleWithTooltip,
  renderBlockField,
  renderInlineField,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/components/OfferSegments/components/OfferSegment/OfferSegment.helpers';

type Styles = ClassProp<ReturnType<typeof styles>>;

const styles = (theme: Theme) => ({
  throttleUpdBtn: {
    backgroundColor: `${theme.violet} !important`,
    color: '#000 !important',
    margin: '0 !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    marginBottom: '0',
    fontWeight: 'bold',
  },
  spacer: {
    paddingRight: '1rem !important',
    paddingBottom: '.5rem !important',
  },
  container: {
    display: 'flex',
  },
  throttleContainer: {
    display: 'flex',
  },
});

type Props = {
  throttle: Throttle;
  handleClick?: React.Dispatch<React.SetStateAction<boolean>>;
  handleEditNameAndDescriptionClick?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  disabled?: boolean;
  classes: Styles;
};

const ThrottleDetails: FunctionComponent<Props> = ({
  throttle,
  handleClick,
  handleEditNameAndDescriptionClick,
  disabled,
  classes,
}) => {
  const { uuid, name, description } = throttle;
  return (
    <div className={classes.container}>
      {renderBlockField('Name:', name, classes)}
      {renderBlockField('Description:', description, classes)}
      <div className={classes.throttleContainer}>
        {renderInlineField(
          'Audience Visibility:',
          formatThrottleWithTooltip(throttle),
          classes,
        )}
        {handleClick && (
          <span className={classes.spacer}>
            <Button
              className={classes.throttleUpdBtn}
              title="Update Throttle"
              onClick={handleClick}
              value={uuid}
              disabled={disabled}
            />
          </span>
        )}
        <span className={classes.spacer}>
          <Button
            className={classes.throttleUpdBtn}
            title="Update Throttle Name and Description"
            onClick={handleEditNameAndDescriptionClick}
            value={uuid}
            disabled={disabled}
          />
        </span>
        <span className={classes.spacer}>
          <ThrottleHistoryModal uuid={uuid} name={name} />
        </span>
      </div>
    </div>
  );
};

export default withStyles(styles)(ThrottleDetails);
